import React from 'react'

import { ButtonClean, useModalContext } from '@fourthwall/components'
import { VideoModal } from '@modules/Dashboard/pages/Apps/components/VideoModal/VideoModal'
import { YouTubeEmbed } from '@modules/Dashboard/pages/Apps/components/YouTubeEmbed/YouTubeEmbed'

import { useOverviewContext } from '../../hooks/useOverviewContext'
import * as S from './styled'

export const Video = () => {
  const modal = useModalContext()
  const overview = useOverviewContext()

  if (overview.isLoading) return null
  if (!overview.onboarding.active) return null

  return (
    <S.Container>
      <div>
        <S.Heading>Launch memberships your community will love</S.Heading>
        <S.Description>
          Allow fans to support you with memberships. Create tiers and offer exclusive content,
          perks and more.{' '}
          <ButtonClean
            label="Learn  more"
            href="https://fourthwall.com/memberships"
            target="_blank"
            withUnderline
          />
        </S.Description>
      </div>

      <S.Video
        onClick={() => {
          modal.open(VideoModal, {
            title: 'Launch memberships your community will love',
            description:
              'Allow fans to support you with memberships. Create tiers and offer exclusive content, perks and more.',
            video: (
              <YouTubeEmbed videoId="HffvS7if72s" parameters={{ autoplay: true, rel: false }} />
            ),
          })
        }}
      >
        <S.VideoThumbnail src="https://img.youtube.com/vi/HffvS7if72s/hqdefault.jpg" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          style={{ position: 'relative' }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64ZM46.2523 33.3607C47.4107 32.8233 47.4107 31.1766 46.2523 30.6392L22.5758 19.6553C21.5816 19.1941 20.4445 19.9201 20.4445 21.016L20.4445 42.9838C20.4445 44.0798 21.5816 44.8058 22.5758 44.3445L46.2523 33.3607Z"
            fill="white"
          />
        </svg>
      </S.Video>
    </S.Container>
  )
}
